<template>
  <div>
    <div class="minheight100" style="background-color: #00b25a">
      <div><img src="./images/tjmbg.png" /></div>
      <div class="input-container">
        <div class="color-gray3" style="font-size: 16px">请输入推荐码</div>
        <div class="phone_code_single">
          <div>
            <input
              ref="input"
              class="cinput"
              adjust-position="false"
              auto-blur="true"
              @blur="codeNumBlurFun"
              @input="codeNumInputFun"
              v-model="code"
              type="password"
              oninput="if(value.length>5)value=value.slice(0,5)"
              onkeyup="value=value.replace(/[\u4E00-\u9FA5]/g,'')"
            />
          </div>
          <div class="codeinput">
            <div
              v-for="(item, index) in 5"
              :key="index"
              @click="codefocusFun(index)"
              :style="
                index == code.length ? 'background-color:rgb(0, 102, 102,0.3);' : 'color: #313131;background-color:#eee'
              "
            >
              {{ code[index] }}
            </div>
          </div>
        </div>
        <div
          class="btn-common block"
          :class="{ 'btn-common-disabled': code.length !== 5 }"
          @click="code.length !== 5 ? null : recommendConfirm()"
        >
          确定
        </div>
      </div>
    </div>
    <Popup v-model="messageShow" class="border-message-popup">
      <div class="message-popup">
        <div class="txt-center mb16"><i class="icon-success"></i></div>
        <div class="titleonly">提交成功</div>
        <div class="btn-common block" @click="recommendJump">领取课程</div>
      </div>
    </Popup>
  </div>
</template>

<script>
import { activityService } from '@/api'
import Message from '../goods/message.vue'
import { Toast, Popup } from 'vant'

export default {
  components: { Popup },
  data() {
    return {
      code: '', // 推荐码
      isCode: false,
      messageShow: false,
      jumpData: ''
    }
  },
  methods: {
    codeNumInputFun(e) {
      console.log(e)
      let val = e.target.value
      this.code = this.code.replace(/[^\w_]/g, '')
      if (this.code.length == 5) this.isCode = false
      else this.isCode = true
    },
    codeNumBlurFun(e) {
      this.$refs.input.blur()
      // let val = e.target.value
      // if (val.length == 5) this.isCode = false
      // else this.isCode = true
    },
    codefocusFun(index) {
      this.$refs.input.focus()
    },
    inputFocus: function () {
      this.$nextTick(x => {
        this.$refs.input.focus()
      })
    },
    recommendConfirm() {
      activityService.activityRecommendJump({ recommendCode: this.code }).then(res => {
        this.jumpData = res
        this.messageShow = true
      })
    },
    recommendJump() {
      if (this.jumpData) window.location.href = this.jumpData
    }
  },
  created() {
    this.inputFocus()
  },
  mounted() {}
}
</script>

<style lang="scss" scoped>
@import 'index.scss';
.input-container {
  background: #fff;
  margin: 20px;
  padding: 20px;
  border-radius: 4px;
}

.phone_code_single {
  margin: 50px 0;

  .cinput {
    position: fixed;
    left: -40px;
    width: 20px;
    height: 20px;
  }
  .codeinput {
    display: flex;
    justify-content: center;
  }

  .codeinput > div {
    margin-top: 2px;
    margin-left: 10px;
    width: 46px;
    height: 46px;
    line-height: 46px;
    font-size: 28px;
    font-weight: bold;
    color: #313131;
    text-align: center;
    border-radius: 8px;
    background-color: rgba($color: #00b25a, $alpha: 0.3);
  }

  .codeinput > div:nth-child(1) {
    margin-left: 0px;
  }
}
</style>
